/* istanbul ignore file */
import React from 'react';
import { ARTIFACT_ID } from '../constants';
import ArtifactUploaderInput from './ArtifactUploaderInput';

const AttachmentUploaderInput = (props: any) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.ATTACHMENT} />;
};

export default AttachmentUploaderInput;
